// src/components/common/ConfirmReasonTextarea.js
//
// The free-TEXT reason box inside a confirm dialog (backdate / invoice-date
// "Other…" reason). It is WRITING, so it follows the one text-correction rule
// (KAN-856): auto-fitting, sentence capitals, autocorrect + spellcheck on, via
// AutoFitTextarea's default prose props.
//
// One line of value (the reason prints on invoices / audit rows): the box
// wraps visually, Enter inserts nothing, pasted line breaks become a space.
// SAFETY: Enter NEVER confirms. The dialog's document
// binding (useModalKeyboard) already ignores a focused TEXTAREA; this field
// also stops plain Enter from bubbling so no future listener can confirm from
// here. The confirm button stays the only way to confirm. The typed-confirm
// PHRASE field and the money field are different components and unchanged.

import AutoFitTextarea from './AutoFitTextarea';
import { typedConfirmInputField } from '../../ui/confirmDialogStyles';
import { collapseLineBreaks, singleLineEnterKeyDown } from '../../utils/ui/textEntryProps';

const style = { ...typedConfirmInputField, resize: 'none', display: 'block', lineHeight: 1.4 };

export default function ConfirmReasonTextarea({ onChange, ...rest }) {
  return (
    <AutoFitTextarea
      rows={1}
      name="confirm-reason"
      autoComplete="off"
      data-1p-ignore="true"
      data-lpignore="true"
      data-form-type="other"
      style={style}
      onKeyDown={singleLineEnterKeyDown}
      onChange={(e) => onChange(collapseLineBreaks(e.target.value))}
      {...rest}
    />
  );
}
